import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import type {
  GridFieldType,
  PassportFieldPaletteSource,
} from '@/features/Inventory/ObjectTypePassportGrid/model/types'
import {
  isElementLinkSelectorCell,
  resolvePassportFieldPaletteSource,
} from '@/features/Inventory/ObjectTypePassportGrid/model/passportFieldPalette'

/**
 * Same resolution as `resolvePassportFieldPaletteSource` / builder grid — which sidebar bucket («own» / parent / list) the cell belongs to.
 */
export function resolveRuntimePaletteSource(
  layoutItem: GridFieldType,
  field: ObjectInventoryField,
  catalogTypeId: number,
): PassportFieldPaletteSource {
  return resolvePassportFieldPaletteSource(layoutItem, catalogTypeId, field)
}

/** «Собственные поля» — editable in passport runtime when not locked (e.g. historical snapshot). */
export function isRuntimeOwnEditableField(
  layoutItem: GridFieldType,
  field: ObjectInventoryField,
  catalogTypeId: number,
): boolean {
  if (isElementLinkSelectorCell(layoutItem)) return true
  return resolveRuntimePaletteSource(layoutItem, field, catalogTypeId) === 'own'
}
